/* eslint-disable no-irregular-whitespace */
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'VRコンテンツの開発で災害に関する教育の効率化',
  title1: 'VRコンテンツの開発で災害に関する教育の効率化',
  introduction_text:
    '水害支援に特化したボランティア活動が体験できるVRコンテンツを作成しました。このプロジェクトはボランティア管理と教育の効率化や水害特有の作業知識の普及を目的としています。弊社はVRコンテンツ作成において、教育目的に焦点を当てた設計を行い、実装まで実現しました。',
  company: '公益財団法人日本財団ボランティアセンター',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  industryTagText: '公共/行政',
  industryTagSrc: '/cases/public/',
  color: '#222',
  background: '#F8F8F8',
  staff1: 'プロジェクトコーディネーター 高野葉朗さん',
  staff2: '常務理事 沢渡一登さん',
  linkText: 'ぼ活！（https://vokatsu.jp/）',
  linkUrl: 'https://vokatsu.jp/',
  image: '/images/img/cases/caseStudyTop/volunteer-ex.webp',
  alt: 'VRコンテンツの開発で災害に関する教育の効率化',
  imgClass: 'fv_img_adjust2',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = 'VRコンテンツによる新たな教育機会をご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '公益財団法人日本財団ボランティアセンターは、2010年に前身「NPO法人日本学生ボランティアセンター」として設立されました。現在は学生だけではなく幅広い世代を対象にボランティアに関する事業を実施している公益財団法人です。',
  },
  {
    text: `アイスリーデザインは、日本財団ボランティアセンターと共同で、水害支援に特化したボランティア活動が体験できるVR（Virtual Reality）コンテンツを開発しました。`,
  },
  {
    text: 'このコンテンツに込めた思い、そして制作プロジェクトとその進行について、公益財団法人日本財団ボランティアセンターの常務理事 沢渡一登さん、プロジェクトコーディネーターの高野葉朗さんにお話を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ボランティア管理と教育の効率化',
        text: '災害が発生するたびに異なるボランティアが参加するため、都度、危険性や作業手順を説明する必要があり、これが大変な労力を要している。',
      },
      {
        title: 'リアルな危険性の理解と体験',
        text: '災害現場特有の危険性を新規ボランティアに理解してもらうための効果的な手法が必要。',
      },
      {
        title: '水害特有の作業知識の普及',
        text: '近年増えている水害への対応として、特有の作業知識や手順を効率よく学ぶ方法が求められている。',
      },
    ],
    solutions: [
      {
        title: 'VRコンテンツの開発による教育効率化',
        text: 'VRを用いて、ボランティアが実際の災害現場で必要な知識や危険性を疑似体験できる教材を提供し、事前教育の効率と効果を向上させる。',
      },
      {
        title: 'リアルな体験提供',
        text: 'VRを通じて、水害時の家屋内の構造把握や安全な作業手順をリアルに体験できる内容を提供し、ボランティアの現場での安全意識を高める。',
      },
      {
        title: '教育内容のゲーミフィケーション',
        text: 'VRコンテンツにおいて、ゲーム的要素を取り入れつつ、教育目的に焦点を当てた設計を行い、学習意欲を刺激し、知識の定着を促進する。',
      },
    ],
  },
]


// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
